import { render, staticRenderFns } from "./CustomPModal.vue?vue&type=template&id=9bf4fab4&scoped=true&"
import script from "./CustomPModal.vue?vue&type=script&lang=js&"
export * from "./CustomPModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf4fab4",
  null
  
)

export default component.exports